<template>
  <div class="space-y-2 prose dark:prose-invert">
    <p>Voxbet (“we,” “our,” “us”) values your privacy and is committed to protecting your personal information.</p>
    <p>This Privacy Policy explains how we collect, use, and safeguard your information when you use our website <a href="https://betpic.com" class="text-blue-600 dark:text-blue-400 underline">betpic.com</a> or any related services.</p>
    <p>By signing up for an account or logging in, you consent to the collection and use of your information as described in this policy.</p>
  </div>  
</template>